import React from "react";
import imageNull from "../assets/Images/NoImage.png";
import business from "../assets/Images/imetanic-logo.png";
import userImg from "src/assets/Images/user-profile.png";

interface ImageProps {
  imagePath: string | File | null | undefined;
  className?: string;
  company?: boolean;
  profile?: boolean;
}

const Image: React.FC<ImageProps> = ({ imagePath, className = "", company = false, profile = false }) => {
  const noImage = company ? business : profile ? userImg : imageNull;

  if (!imagePath) {
    return <img src={noImage} alt='No-Image' className={`object-contain ${className}`} />;
  }

  const getSrc = (): string => {
    // File object → blob URL
    if (imagePath instanceof File) {
      return URL.createObjectURL(imagePath);
    }

    // Already a full data URI
    if (imagePath.startsWith("data:image")) {
      return imagePath;
    }

    // Raw Base64 string — must be long and contain no path characters
    const isRawBase64 =
      imagePath.length > 200 &&
      !imagePath.includes("/") === false || // not a path
      /^[A-Za-z0-9+]+=*$/.test(imagePath) && imagePath.length > 200;

    if (isRawBase64) {
      return `data:image/png;base64,${imagePath}`;
    }

    // Blob URL (local preview)
    if (imagePath.startsWith("blob:")) {
      return imagePath;
    }

    // S3 or any full URL
    if (imagePath.startsWith("https://") || imagePath.startsWith("http://")) {
      return imagePath;
    }

    // Relative path — prepend env base URL
    return `${process.env.REACT_APP_IMAGE_PATH}/${imagePath}`;
  };

  return (
    <img
      src={getSrc()}
      alt="img"
      className={`object-contain ${className}`}
      onError={(e) => {
        e.currentTarget.src = noImage;
      }}
    />
  );
};

export default Image;
